import each from 'lodash/each'
import get from 'lodash/get'

// The tickCallback needs to return what label
// to render on the x axis ticks.
// It needs to accomplish:
//  - Show the current age (first tick)
//  - Show the last age (last tick)
//  - Show the retirementAge if its not too close
//    to any other tick
//  - Show the age at which any projection goes to
//    0 if its not too close to any other tick
//
//  The closure starts with an empty tickListAccumulator.
//  As Chartjs calls the tickCallback function, we will
//  dynamically determine whether we want to render the
//  tick, and then add it to the tickListAccumulator.
//  The tickListAccumulator will be used to determine if
//  any new tick is too close to existing ticks.

export const tickCallbackClosure = () => {
  const tickIndexAccumulator = []

  return function (_value, index) {
    const {
      chart: { data: { labels, datasets } }
    } = this
    each(datasets, (dataset) => {
      const tickIndexes = get(dataset, 'tickIndexes', [])
      if (tickIndexes.includes(index) && indexIsFarEnoughFromOtherTicks(index, tickIndexAccumulator)) {
        tickIndexAccumulator.push(index)
      }
    })
    if (tickIndexAccumulator.includes(index)) {
      return `${labels[index]}`
    }
  }
}

const indexIsFarEnoughFromOtherTicks = (newTickIndex, tickIndexAccumulator) => {
  return tickIndexAccumulator.every((tickIndex) => Math.abs(newTickIndex - tickIndex) > 3)
}
